import {
  CartIcon,
  DocumentIcon,
  HomeIcon,
  SettingsIcon,
  StatsIcon,
} from 'components/icons/Icons';

import Dashboard from 'views/admin/dashboard';
import Transactions from 'views/admin/transactions';
import Categories from 'views/admin/categories';
import Reports from 'views/admin/reports';
import Settings from 'views/admin/settings';

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <HomeIcon width="20px" height="20px" color="inherit" />,
    component: <Dashboard />,
  },
  {
    name: 'Transactions',
    layout: '/admin',
    path: '/transactions',
    icon: <CartIcon width="20px" height="20px" color="inherit" />,
    component: <Transactions />,
  },
  {
    name: 'Categories',
    layout: '/admin',
    path: '/categories',
    icon: <DocumentIcon width="20px" height="20px" color="inherit" />,
    component: <Categories />,
  },
  {
    name: 'Reports',
    layout: '/admin',
    path: '/reports',
    icon: <StatsIcon width="20px" height="20px" color="inherit" />,
    component: <Reports />,
  },
  {
    name: 'Settings',
    layout: '/admin',
    path: '/settings',
    icon: <SettingsIcon width="20px" height="20px" color="inherit" />,
    component: <Settings />,
  },
];

export default routes;
